"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _Uri = _interopRequireDefault(require("../Uri"));

class UriImmutable extends _Uri.default {
  /**
   * @inheritdoc
   */
  constructor(scheme, userInfo, host, port, path, query, fragment) {
    super(scheme, userInfo, host, port, path, query, fragment);
    const {
      setScheme,
      setUserInfo,
      setHost,
      setPort,
      setPath,
      setQuery,
      setFragment
    } = this;

    this.setScheme = function (scheme) {
      return setScheme.call(this.clone(), scheme);
    };

    this.setUserInfo = function (userInfo) {
      return setUserInfo.call(this.clone(), userInfo);
    };

    this.setHost = function (host) {
      return setHost.call(this.clone(), host);
    };

    this.setPort = function (port) {
      return setPort.call(this.clone(), port);
    };

    this.setPath = function (path) {
      return setPath.call(this.clone(), path);
    };

    this.setQuery = function (query) {
      return setQuery.call(this.clone(), query);
    };

    this.setFragment = function (fragment) {
      return setFragment.call(this.clone(), fragment);
    };
  }

  clone() {
    const uri = new UriImmutable(this.scheme, this.userInfo, this.host, this.port, this.path, this.query, this.fragment);
    return uri;
  }

}

exports.default = UriImmutable;